import React, {useState} from 'react';

import {EXPORT_DISPLAY_NAME, MoleculeExportFormat} from 'chemistry/ChemistryConstants';
import * as FileUtil from 'folder-items/FileUtil';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import Modal from 'ui-library/modals/Modal';
import * as net from 'util/Net';

interface FormatItem {
  name: string;
  handleOnClick: () => void;
}

export interface ExportMoleculeModalProps {
  editURL: string;
  onRequestClose: () => void;
}

export default function ExportMoleculeModal(props: ExportMoleculeModalProps): JSX.Element {
  const [format, setFormat] = useState<MoleculeExportFormat | null>(null);

  const getFormatItems = (): Array<FormatItem> =>
    Object.values(MoleculeExportFormat).map((format) => ({
      name: EXPORT_DISPLAY_NAME[format],
      handleOnClick: () => {
        setFormat(format);
      },
    }));

  const getExportUrl = (): string => FileUtil.getExportURL(props.editURL, format!, {dl: true});

  const handleDownload = (): void => {
    net.submitCSRFForm('POST', getExportUrl(), {target: '_blank'});
  };

  const getDisplayName = (): string => {
    if (format == null) {
      return 'Choose Molecule Format...';
    }
    return EXPORT_DISPLAY_NAME[format];
  };

  return (
    <Modal
      enableRedesign={true}
      title="Export Molecule"
      onRequestClose={props.onRequestClose}
      medium={true}
      buttons={[
        {
          text: 'Download',
          submit: true,
          style: 'success',
          disabled: !format,
          onClick: handleDownload,
          dataTestAttrs: {component: 'ExportMoleculeModal', element: 'submit'},
        },
        {
          text: 'Cancel',
          onClick: props.onRequestClose,
        },
      ]}
    >
      <div className="form-group">
        <SelectDropdown
          displayName={getDisplayName()}
          menu={
            <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL}>
              {getFormatItems().map((formatItem) => (
                <Option key={formatItem.name} onSelect={formatItem.handleOnClick}>
                  {formatItem.name}
                </Option>
              ))}
            </Menu>
          }
        />
      </div>
    </Modal>
  );
}
